import type { FC, PropsWithChildren } from 'react';

import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

interface HandoffRequestContainerProps extends PropsWithChildren {
  testId: string;
}

export const HandoffRequestContainer: FC<HandoffRequestContainerProps> = ({
  children,
  testId,
}) => {
  return <Container data-testid={testId}>{children}</Container>;
};

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 266px;
  padding: ${theme.spacing(9)};
  border-radius: 8px;
  background: ${theme.palette.grey[900]};
`;
